import SrSelectPeople from "./index.vue";

SrSelectPeople.install = function(Vue) {
  Vue.component(SrSelectPeople.name, SrSelectPeople);
};

export default SrSelectPeople;



// WEBPACK FOOTER //
// ./packages/SrSelectPeople/index.js